import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import PlatformProvider from "./states/platformContext";
import "./utils/i18n";

import "./assets/css/index.css";
import { FlightProvider } from "states/flightContext";
import { HotelProvider } from "states/hotelContext";
import { LoadingProvider } from "states/loadingContext";
import { MessageProvider } from "states/messageContext";
import MessageModal from "component/Common/MessageModal";
import { ErrorBoundary } from "react-error-boundary";
import ErrorComponent from "component/Common/ErrorComponent";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <ErrorBoundary fallback={<ErrorComponent />}>
            <PlatformProvider>
                <FlightProvider>
                    <HotelProvider>
                        <MessageProvider>
                            <LoadingProvider>
                                <HelmetProvider>
                                    <App />
                                </HelmetProvider>
                            </LoadingProvider>
                            <MessageModal />
                        </MessageProvider>
                    </HotelProvider>
                </FlightProvider>
            </PlatformProvider>
        </ErrorBoundary>
    </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
